import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Store } from "@ngxs/store";
import {
  PlanningPortalGlobalState,
  PlanningPortalGlobalStateModel
} from "../../../state/planning-portal-global-state/planning-portal-global.state";
import { Observable } from "rxjs";

@Injectable()
export class HttpSuscriptionKeyInterceptor implements HttpInterceptor {
    
  constructor(private store: Store) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {

    const ocpApimSubscriptionKey = this.store.selectSnapshot(
      PlanningPortalGlobalState.SubscriptionKeyInterceptor
    );
    
    const request = req.clone({
      setHeaders: {
        "Ocp-Apim-Subscription-Key": ocpApimSubscriptionKey ?? ""
      },
    });

    return next.handle(request);
  }
}
